export enum BudgetLength {
  SHORT = 'short',
  LONG = 'long',
}
